// extracted by mini-css-extract-plugin
export default {"localeSwitcher":"localeSwitcher__vUc7-"};